// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__egGID","rootSmall":"AddTileButton_rootSmall__HoZeP"};